<template>
  <div class="fixed right-10 bottom-10 z-50 flex items-center flex-row-reverse">
    <!-- Main Help Button -->
    <button
      @click="toggleExtension"
      class="w-12 h-12 md:w-auto md:px-4 flex items-center justify-center rounded-full dark:bg-sub-800 text-white shadow-lg dark:hover:bg-sub-900 bg-main-700 hover:bg-main-900 transition-all duration-300 flex-shrink-0 group"
    >
      <!-- Mobile: Just question mark -->
      <span class="md:hidden text-xl font-bold">?</span>

      <!-- Desktop: Help text with icon -->
      <span class="hidden md:flex items-center gap-2">
        <svg
          class="w-5 h-5 group-hover:scale-110 transition-transform"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M9.09 9C9.3251 8.33167 9.82115 7.76811 10.4765 7.43926C11.1319 7.1104 11.8927 7.04238 12.6003 7.24976C13.3079 7.45714 13.9037 7.92372 14.2616 8.55277C14.6195 9.18182 14.7115 9.9243 14.5175 10.6249C14.3236 11.3255 13.8606 11.9338 13.2316 12.3287C12.6026 12.7236 11.8579 12.8744 11.135 12.7501C10.4122 12.6257 9.76962 12.2365 9.34 11.6666"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M12 16V15.98"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        Help
      </span>
    </button>

    <!-- Extension Panel (slides left) -->
    <transition name="slide-left">
      <div
        v-if="isExtended"
        class="mr-2 bg-white rounded-lg shadow-xl p-2 flex space-x-2 border border-gray-100"
      >
        <button
          @click="openChat"
          class="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors group relative"
          title="Chat Support"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 dark:text-sub-800 dark:group-hover:text-sub-900 text-main-700 group-hover:text-main-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
          <span
            class="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            Chat
          </span>
        </button>

        <button
          @click="playHelpVideo"
          class="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors group relative"
          title="Video Help"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 dark:text-sub-800 dark:group-hover:text-sub-900 text-main-700 group-hover:text-main-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
          <span
            class="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            Video
          </span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus";
export default {
  name: "HelpButton",
  inject: ["helpVideoURL"],
  data() {
    return {
      isExtended: false,
    };
  },
  methods: {
    playHelpVideo() {
      eventBus.emit("open-help-video", this.helpVideoURL);
      this.isExtended = false;
    },
    toggleExtension() {
      this.isExtended = !this.isExtended;
    },
    openChat() {
      this.isExtended = false;
    },
  },
};
</script>

<style scoped>
.slide-left-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-left-leave-active {
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
